const monoStack = "Menlo, 'IBM Plex Mono', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', 'Courier New', monospace";

const theme = {
  fonts: {
    body: monoStack,
    heading: monoStack,
    monospace: monoStack
  }
};

export default theme;
